export default __webpack_public_path__ + "static/media/carol.ce8b2961.jpg";